import { HttpClient, HttpEventType, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable, OnInit } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, throwError } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class DataService implements OnInit {

  private sharedData = new BehaviorSubject<any>(null);
  public currentData$ = this.sharedData.asObservable();

  private modelData = new BehaviorSubject<any>(null);
  public modelData$ = this.modelData.asObservable();

  constructor(private http: HttpClient) { }

  ngOnInit() { }


  getData(json: string | null) {
    if (json === null) json = 'data-test-1';
    let endpoint = (json.match(/^http?:\/\//)) ? json : environment.api_base_url + json;
    //let endpoint = (json.match(/^http?:\/\//)) ? json : '/assets/mock/' + json + '.json';
    return this.http.get<any>(endpoint)
      .pipe(map(json => json));
  }

  getDataByURL(endpoint: string, id: number | undefined | false): Observable<any> {

    return this.http.get<any>(environment.api_base_url + endpoint + `/${id}`)
  }

  addData(model: any, endpoint: string): Observable<any> {
    return this.http.post<any>(environment.api_base_url + endpoint, model)
      .pipe(
        catchError(error => this.handleError(error))
      )
  }

  putData(model: any, endpoint: string): Observable<any> {
    return this.http.put<any>(environment.api_base_url + endpoint, model)
      .pipe(
      //catchError(this.handleError())
    );
  }

  patchData(model: any, endpoint: string): Observable<any> {
    return this.http.patch<any>(environment.api_base_url + endpoint, model)
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  public associaFile(endpoint: string, model: any): Observable<any> {
    return this.http.post<any>(environment.api_base_url + endpoint, model).pipe(
      catchError(error => this.handleError(error))
    )
  }

  public updateFile(endpoint: string, formData: FormData): Observable<any> {
    return this.http.put<any>(environment.api_base_url + endpoint, formData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      map(event => this.getUploadProgress(event)),
    );
  }

  public uploadFile(endpoint: string, formData: FormData): Observable<any> {
    return this.http.post<any>(environment.api_base_url + endpoint, formData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      map(event => this.getUploadProgress(event)),
    );
  }

  private getUploadProgress(event: any): number | null {    
    if (event.type === HttpEventType.UploadProgress) {
      const percentDone = Math.round((event.loaded / event.total) * 100);
      return percentDone === 100 ? 99 : percentDone;
    }
    
    // SOLO quando riceviamo la vera risposta (200 OK) dal backend, inviamo il 100%
    if (event.type === HttpEventType.Response) {
      return 100;
    }
    
    return null;
  }

  public downloadFile(endpoint: string, fileId: number): Observable<HttpResponse<Blob>> {
    const url = fileId < 0 ? environment.api_base_url + endpoint : `${environment.api_base_url + endpoint}/${fileId}`;
    return this.http.get(url, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  getFiles(endpoint: string): Observable<any> {
    return this.http.get<File[]>(environment.api_base_url + endpoint);
  }

  deleteData(endpoint: string, body: {} | null = null) {
    let options: any = {
      headers: this.setHeaders()
    }
    if (body !== null) {
      options['body'] = body;
    }
    this.http.delete(environment.api_base_url + endpoint, options)
      .subscribe({
        next: data => {
          window.location.reload();
          //this.status = 'Delete successful';
        },
        error: error => {
          //this.errorMessage = error.message;
          console.error('There was an error!', error);
        }
      });
  }


  setData(data: {}) {
    this.sharedData.next(data)
  }

  setModelData(data: {}) {
    this.modelData.next(data)
  }

  setHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
  }

  private handleError(error: any) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
      // Use the following instead if using lite-server
      // return Observable.throw(err.text() || 'backend server error');
    }
    return throwError(error || 'server error');
  }

  /*
  getPeople(term: string = null): Observable<Person[]> {
    let items = getMockPeople();
    if (term) {
        items = items.filter(x => x.name.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1);
    }
    return of(items).pipe(delay(500));
  }
  */

}

